import { render, staticRenderFns } from "./StatusErro.vue?vue&type=template&id=c55af136&scoped=true&"
import script from "./StatusErro.vue?vue&type=script&lang=js&"
export * from "./StatusErro.vue?vue&type=script&lang=js&"
import style0 from "./StatusErro.vue?vue&type=style&index=0&id=c55af136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55af136",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
